import { clsx } from 'clsx';

type Options = {
  isMulti: boolean;
  isTop3: boolean;
};

export const prepareStyles = (styles: Record<string, string>, { isMulti, isTop3 }: Options): string => {
  let contStyles = clsx(styles['container'], 'search-page-card');

  if (isMulti) {
    contStyles = clsx(contStyles, styles['container-multi']);
  } else if (isTop3) {
    contStyles = clsx(contStyles, styles['container-top3']);
  }

  return contStyles;
};
